import React, { useState } from 'react';
import { useTranslation} from "react-i18next";

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import ThemeInfo from './ThemeInfo';


export default function Main({ core, config }) {

  const { layer, viewer, mainMap, actions, models } = config;
  const { getWindowSize, showOnPortal, isComponentExcludedForLayer } = models.Utils;  

  const { t } = useTranslation(["common", "custom"]);

  const [modalThemeInfoOpen, setModalThemeInfoOpen] = useState(false);

  const wsize = getWindowSize();
  const isMobile = wsize[0] <= 768;

  const exclude = isComponentExcludedForLayer(viewer, layer, "LayerMetadata");

  if (exclude) return null;

  return (
    <React.Fragment>

      <Button icon="pi pi-info-circle"
        title={t("metadataInfo", "Informação de Metadados")}
        color="blue"
        size="small" rounded text
        className="tool"
        onClick={e => setModalThemeInfoOpen(layer)}
      />

      {showOnPortal(<Dialog 
        header={t("themeInfo", "Informação do Tema")}
        visible={!!modalThemeInfoOpen}
        style={{width: isMobile ? '90%' : '50vw' }}  
        modal 
        onHide={e => setModalThemeInfoOpen(false)}>
        <ThemeInfo
          viewer={viewer}
          mainMap={mainMap}
          core={core}
          models={models}
          theme={modalThemeInfoOpen}
          downloadTheme={theme => actions.downloadTheme(theme)}
        />
      </Dialog>)}
    </React.Fragment>
  )
}
